import { render, staticRenderFns } from "./TicketCreateGeralFields.vue?vue&type=template&id=3cdcf597&"
import script from "./TicketCreateGeralFields.vue?vue&type=script&lang=js&"
export * from "./TicketCreateGeralFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports